export default "__VITE_ASSET__r6G0HMrc__"